<template>
    <div class="load-bag" v-if="showLoader2">
    <div class="lds-ripple" ><div></div><div></div></div>
    </div>
       <Dashboard/>
        <!-- Main Content -->
        <div class="main-content">
          <section class="section">
            <div class="section-header">
              <h1>Parking Request Management</h1>
              <div class="section-header-breadcrumb">
                <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
                <div class="breadcrumb-item">Parking Request Management</div>
              </div>
            </div>
            <div class="section-body">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header d-Fle">
                      <h4 class="hide">Export Table</h4>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive newPc">
                        <table
                          class="table table-bordered table-hover"
                          id="tableExport"
                          style="width: 100%"
                        >
                          <thead>
                            <tr>
                              <th>S No.</th>
                              <th>Name</th>
                              <th>Date</th>
                              <th>Time</th>
                              <th>Price</th>
                              <th>Location</th>
                              <th>Purpose</th>
                              <th>status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,index) in result" :key="item._id">
                              <td>{{index+1}}</td>
                              <td>{{item.name.replace(/^./, item.name[0].toUpperCase())}}</td>
                              <td>{{item.date}}</td>
                              <td>{{item.from}} - {{item.to}}</td>
                              <td>{{item.price}}$</td>
                              <td>{{item.location}}</td>
                              <td>{{item.purpose_of_visit}}</td>
                              <td v-if="item.accept==true">Confirmed.</td>
                              <td v-else>Pending</td>
                              <td class="action">
                                <a @click="DeleteParkingRequest(item._id)"><i class="far fa-trash-alt"></i></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </section>
        </div>
  </template>
  <script>
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import Dashboard from '@/components/Dashboard.vue'
  import axios from "../services/customAxios";
  import { base_url } from "../config";
  export default defineComponent({
    name: 'UserManagement',
    components: {
      Dashboard,
    },
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data(){
      return{
        result:[],       
        base_url: base_url,
        showLoader:false,
        showLoader2:true,
      }
    },
    methods:{
      async LoadParkingRequest() {
        try{
        let response = await axios.get(`${base_url}/get_all_parking_request`); 
        console.log("Parkings==========>>>>>",response.data.result);
        this.result = response.data.result.reverse();
      }
      catch (error) {
        if (error) {
          this.showLoader= false;
            this.result = [];
          }
        }
      },
      async DeleteParkingRequest(_id) {
        if (confirm("Are you sure you want to delete this Request?")) {
           await axios.delete(`${base_url}/delete_parking_request/` + _id);
          this.LoadParkingRequest();
        }
      }, 
    },
    async mounted(){
      this.LoadParkingRequest();      
      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
      setTimeout(() => {
        document.body.appendChild(recaptchaScript)  
        this.showLoader2= false
      }, 3000);  
    }
  });
  </script>
  
  <style>

  </style>